import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-filter-block',
  templateUrl: './filter-block.component.html',
  styleUrls: ['./filter-block.component.scss']
})
export class FilterBlockComponent implements OnInit {

  @Input() title: string;

  @Input() sticky: boolean = false;

  constructor() { }

  ngOnInit(): void { }

}
